import { alpha } from '@mui/material/styles';
import { JLR_PLANT } from '../../constants';

export default function Dialog(theme) {
  const isJlr = theme.plantName === JLR_PLANT;
  const isDarkMode = theme.palette.mode === 'dark';

  const jlrDialogStyles = {
    paper: {
      backgroundImage: 'none',
      background: isDarkMode 
        ? 'linear-gradient(135deg, #1a1d20, #2d3136)'
        : 'linear-gradient(135deg, #ffffff, #fafbfc)',
      borderRadius: '24px',
      border: `1px solid ${isDarkMode 
        ? 'rgba(255, 255, 255, 0.1)' 
        : 'rgba(45, 74, 45, 0.1)'}`,
      boxShadow: isDarkMode 
        ? '0 24px 80px rgba(0, 0, 0, 0.4), 0 8px 32px rgba(0, 0, 0, 0.2)'
        : '0 24px 80px rgba(45, 74, 45, 0.15), 0 8px 32px rgba(45, 74, 45, 0.08)',
      backdropFilter: 'blur(20px)',
      
      // Elegant overlay pattern
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '2px',
        background: isDarkMode 
          ? 'linear-gradient(90deg, transparent, #0066cc, #c8b99c, transparent)'
          : 'linear-gradient(90deg, transparent, #2d4a2d, #c8b99c, transparent)',
        borderRadius: '24px 24px 0 0',
      },
    },
    backdrop: {
      background: isDarkMode 
        ? 'rgba(0, 0, 0, 0.7)'
        : 'rgba(45, 74, 45, 0.2)',
      backdropFilter: 'blur(8px)',
    },
  };

  const standardDialogStyles = {
    paper: {
      backgroundImage: 'none',
      borderRadius: '12px',
      boxShadow: theme.shadows[24],
    },
    backdrop: {
      background: 'rgba(0, 0, 0, 0.5)',
    },
  };

  const styles = isJlr ? jlrDialogStyles : standardDialogStyles;

  return {
    MuiDialog: {
      styleOverrides: {
        paper: styles.paper,
        backdrop: styles.backdrop,
      },
    },
    
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: isJlr ? "'Inter', sans-serif" : theme.typography.fontFamily,
          fontWeight: isJlr ? 600 : 500,
          fontSize: isJlr ? '1.5rem' : '1.25rem',
          color: isJlr ? (isDarkMode ? '#ffffff' : '#2d4a2d') : theme.palette.text.primary,
          padding: isJlr ? '24px 32px 16px' : '20px 24px 16px',
          borderBottom: `1px solid ${isJlr 
            ? (isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(45, 74, 45, 0.1)')
            : theme.palette.divider}`,
          letterSpacing: isJlr ? '0.5px' : 'normal',
        },
      },
    },

    MuiDialogContent: {
      styleOverrides: {
        root: {
          fontFamily: isJlr ? "'Inter', sans-serif" : theme.typography.fontFamily,
          padding: isJlr ? '24px 32px' : '20px 24px',
          color: isJlr ? (isDarkMode ? '#ffffff' : '#2d4a2d') : theme.palette.text.primary,
        },
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: isJlr ? '16px 32px 24px' : '16px 24px',
          borderTop: `1px solid ${isJlr 
            ? (isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(45, 74, 45, 0.1)')
            : theme.palette.divider}`,
          gap: isJlr ? '12px' : '8px',
        },
      },
    },

    MuiDialogContentText: {
      styleOverrides: {
        root: {
          fontFamily: isJlr ? "'Inter', sans-serif" : theme.typography.fontFamily,
          color: isJlr ? (isDarkMode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(45, 74, 45, 0.8)') : theme.palette.text.secondary,
          lineHeight: 1.6,
        },
      },
    },
  };
}
